import React from 'react';
import { useDispatch } from 'react-redux';

import Button from '../../../components/buttons/Button';

import { onboardingGotoStep, onboardingStepPassed } from '../onboardingActions';

import './OnboardingTooltipCloseButton.scss';

const OnboardingTooltipButton: React.FC<{
    gotoStep?: string;
    acknowledgeStep?: string;
    className?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}> = ({ children, className, style, gotoStep, acknowledgeStep }) => {
    const dispatch = useDispatch();

    const onButtonClick = () => {
        if (acknowledgeStep) {
            dispatch(onboardingStepPassed(acknowledgeStep));
        }

        if (gotoStep) {
            dispatch(onboardingGotoStep(gotoStep));
        }
    };

    return (
        <Button className={className || 'StyledButton primary compact'} onClick={onButtonClick} style={style}>
            {children}
        </Button>
    );
};

export default OnboardingTooltipButton;
